module.exports = __webpack_public_path__ + "img/HZ-P1009.c9d20fcc.jpg";